import { Table, TableColumnsType } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import qs from 'qs';
import config from "../../../lib/config";
import Pagination from "../../Pagination";
import { IGetMembers, IMemberParams } from "../../../models/members.model";
import useAxios from "../../../hooks/useAxios";
import { getMembers } from "../../../api/members.api";
import Loader from "../../Loader";
import ErrorResponse from "../../ErrorResponse";
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

interface IProps {
  memberCode: string;
}

const MemberTable: FC<IProps> = ({
  memberCode,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { data: res, isLoading, error, execute } = useAxios<IGetMembers>();

  const [pageNo, setPageNo] = useState(1);
  const [params, setParams] = useState<any>({});

  useEffect(() => {
    doGetMembers();
  }, [query.page, query.memberType, query.privacyInfo, query.keyword]);
  
  const doGetMembers = () => {
    const _params: any = {
      pageNo: pageNo,
      perPage: config.smallPageSize,
      memberType: 'S,P',
    };

    if (query.page) {
      _params.pageNo = Number(query.page);
      setPageNo(_params.pageNo);
    };
    if (query.memberType) {
      _params.memberType = String(query.memberType);
    };
    if (query.privacyInfo && query.keyword) {
      _params[String(query.privacyInfo)] = String(query.keyword);
    };

    execute(getMembers(_params));

    _params.page = _params.pageNo;
    delete _params.pageNo;
    delete _params.perPage;
    if (query.privacyInfo && query.keyword) {
      _params.privacyInfo = String(query.privacyInfo);
      _params.keyword = String(query.keyword);
      delete _params[String(query.privacyInfo)];
    };

    setParams(_params);
  };

  const columns: TableColumnsType<object> = [
    {
      title: t('homepage.member.21'),
      dataIndex: 'memberType',
      key: 'memberType',
    },
    {
      title: t('homepage.member.33'),
      dataIndex: 'webId',
      key: 'webId',
    },
    {
      title: t('homepage.member.17'),
      dataIndex: 'memberKorName',
      key: 'memberKorName',
    },
    {
      title: t('homepage.member.36'),
      dataIndex: 'memberEngName',
      key: 'memberEngName',
    },
    {
      title: t('homepage.member.34'),
      dataIndex: 'mobilePhone',
      key: 'mobilePhone',
    }
  ];

  const dataSource = res?.data;

  const modifiedDataSource = dataSource?.map(item => ({
    ...item,
    memberType: item.memberType === 'P' ? t('homepage.member.10') : t('homepage.member.11'),
  }));

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="comm-bx__between">
        <div className='comm-sch_result'>
          {t('common.text.count')}: <b>{res?.total}</b>{t('common.text.unit')}
        </div>
      </div>
      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={modifiedDataSource}
          pagination={{
            current: pageNo,
            pageSize: config.smallPageSize
          }}
          onRow={(record: IMemberParams) => {
              return {
                onClick: () => {
                  if (memberCode !== record.memberCode) {
                    history.push(`/homepage/member?${qs.stringify({
                    ...params,
                    memberCode: record.memberCode,
                    })}
                  `);
                }
              },
            };
          }}
          rowClassName={(record: any) => record.memberCode === memberCode ? 'chosen' : 'pointer'}
        />
      </div>
      <div className="comm-bx__between">
        <div className="common-paging right">
          <Pagination
            count={res?.total || 0}
            page={pageNo}
            param={params}
            path="/homepage/member"
            small
          />
        </div>
      </div>
    </>
  )
}

export default MemberTable;